export function getCookie(name) { // eslint-disable-line
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return '';
}



// WEBPACK FOOTER //
// ./src/utils/cookieHelper.js